'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _hy_AM = require('../locale/hy_AM');

var _hy_AM2 = _interopRequireDefault(_hy_AM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _hy_AM2['default'];